import { Calculator } from './components/calculator/Calculator';
import { Hero } from './components/Hero';

import styles from './TariffCalculator.module.scss';

export const TariffCalculator = () => {
	return (
		<>
			<Hero />
			<main className={styles.appMain}>
				<Calculator />
			</main>
		</>
	);
};
